import React, { useEffect, useState } from "react";
import NavHeader from "../nav/NavHeader";
import SideMenu from "../nav/Sidemenu";
import Skeleton from "react-loading-skeleton";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Analtyics from "../pageLayouts/Analtyics";
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import Login from "./Login";
import { apiService } from "../../services/apiClient";
import { apiUrl } from "../../services/apiUrl";
import { getToken } from "../auth/authConfig";
import UserManagement from "../userAdmin/UserManagement";
import UserRegistration from "../userAdmin/UserRegistrationTab";
import AddFaqs from "../pageLayouts/AddFaqs";
import TabStrip from "../layout/TabStrip";
import PageHeader from "../layout/PageHeader";
import AccessDenied from "../layout/AccessDenied";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && <Box sx={{ p: 0 }}><Typography component="div">{children}</Typography></Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const UserAdministration = () => {
  const [Tabvalue, setTabValue] = useState(0);
  const [passtoken, setPasstoken] = useState(null);
  const [dataItems, setData] = useState();
  const [DataLoading, setDataLoading] = useState(true);

  const tabHeader = [
    { TabHeader: "User Management" },
    { TabHeader: "User Registration" },
    { TabHeader: "FAQs" },
    { TabHeader: "Analytics" },
  ];

  useEffect(() => {
    const initToken = async () => {
      const token = await getToken();
      setPasstoken(token);
    };
    initToken();
  }, []);

  useEffect(() => {
    if (!passtoken) return;
    const fetchTracking = async () => {
      try {
        const response = await apiService.get(apiUrl.aipdCompleteTracking());
        setData(Array.isArray(response.data) ? response.data[0] : response.data);
        setDataLoading(false);
      } catch (err) {
        console.error("Error:", err);
        setData({});
        setDataLoading(false);
      }
    };
    fetchTracking();
  }, [passtoken]);


  return (
    <div>
      <AuthenticatedTemplate>
        <div id="AdminPage">
          <NavHeader />
          <SideMenu />
          {true ? (
            <>
              <div style={{ position: "relative" }} id="main">
                <PageHeader
                  title="User Administration"
                  subtitle="Manage users, registrations, FAQs and platform analytics"
                />
                <Box sx={{ width: "100%" }}>
                  <TabStrip
                    tabs={tabHeader.map(t => t.TabHeader)}
                    active={Tabvalue}
                    onChange={setTabValue}
                  />

                  <CustomTabPanel className="TabPannel" value={Tabvalue} index={0}>
                    <UserManagement passtoken={passtoken} />
                  </CustomTabPanel>

                  <CustomTabPanel className="TabPannel2" value={Tabvalue} index={1}>
                    <UserRegistration />
                  </CustomTabPanel>

                  <CustomTabPanel className="TabPannel3" value={Tabvalue} index={2}>
                    <AddFaqs />
                  </CustomTabPanel>

                  <CustomTabPanel className="TabPannel4" value={Tabvalue} index={3}>
                    {!DataLoading && (
                      // <LineChats dataLoading={DataLoading} jsonData={dataItems} />
                      <Analtyics
                        dataLoading={DataLoading}
                        jsonData={dataItems}
                      />
                    )}

                    {DataLoading && (
                      <>
                        <Skeleton height="400px" />
                        <span style={{ paddingTop: "10px", display: "block" }}>
                          Thank you for your patience! We're in the process of
                          gathering the data needed to create your graph
                        </span>
                      </>
                    )}
                  </CustomTabPanel>
                </Box>
              </div>
            </>
          ) : (
            <div id="main">
              <AccessDenied />
            </div>
          )}

        </div>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </div>
  );
};

export default UserAdministration;
